import type { SchoolCalendar } from 'Services/ControlDataManagement/Features/SchoolCalendar/types'
import type { FetchListParams } from 'Services/ControlDataManagement/types'

export interface School {
  id: string
  created_timestamp: Date
  modified_timestamp: Date
  school_id: string
  school_unit_id: string
  codespace_id: string
  calendar_id: string | null
  name: string
  school_calendar: SchoolCalendar
}

export interface SchoolListResponse {
  total_results: number
  next_page: string | null
  resources: School[]
}

export interface FetchSchoolListParams extends FetchListParams {
  codespace_id?: string
  school_id?: string
  search_text?: string
}

export enum SchoolTabType {
  DETAILS = 'details',
  UNITS = 'units'
}
